// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2s8xB","Label":"Input_Label__2vJIQ","InputElement":"Input_InputElement__3Gk--","Invalid":"Input_Invalid__3rZso"};